import type { Release } from '../releases.ts';

export default {
  version: '0.21.0',
  date: '2026-10-03',
  title: 'Roles you can edit, and deleting users',
  summary: [
    'Roles can be edited, and administrators can add their own',
    'Role pickers list your roles by name',
    'Administrators can delete a person; their assets are kept',
    'A person in another workspace can be removed from this one instead',
    'Fixed: editing a metadata field respects a permission granted to one member',
  ],
  features: [
    'Roles are stored in PRISM and can be edited: the Administrator, Media Manager, Editor and Viewer roles keep their defaults, and an administrator can change what each one may do or add roles of their own (the Administrator role stays fixed and is the only one with the Administer permission)',
    'Administration → Access has a Roles section: edit a role’s name, description and permissions, add a role (optionally starting from an existing one), delete a role that nothing uses (with the reason shown when something still does), restore a built-in role to its defaults and change the order',
    'Role pickers for members, API keys, workflow approval steps and metadata field permissions now list your roles by name',
    'Administrators can delete a person from Administration → Access: the account is closed and signed out everywhere, their collections are deleted (assets are never deleted), open tasks assigned to them become unassigned, and history keeps their name marked “(deleted)”; the dialog shows what will happen and asks for their email to confirm, and the email address can be invited again as a new person',
    'A person who also belongs to a workspace you do not administer can be removed from this workspace instead',
  ],
  fixes: [
    'Editing a metadata field now respects a permission granted to a single member, not only the role',
  ],
} satisfies Release;
